// extracted by mini-css-extract-plugin
export var active = "_ih-2";
export var recordingDot = "_ih-1";
export var recordingIndicator = "_ih-0";